import _ from 'lodash';
import { FC, useEffect } from 'react';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

type SolutionSectionProps = {
  productName: string;
};

const SolutionSection: FC<SolutionSectionProps> = ({ productName }) => {
  useEffect(() => {
    // this is only left wrapper
    const leftContainerOriginallyHovered = document.querySelector('.card.hovered');
    const leftHoverElement = document.querySelectorAll('.left-wrapper .card-hover');
    const rightHoverElement = document.querySelectorAll('.right-wrapper .card-hover');

    leftHoverElement.forEach((el) => {
      el.addEventListener('mouseenter', () => {
        const card = el.closest('.card');
        if (leftContainerOriginallyHovered && el !== leftContainerOriginallyHovered) {
          leftContainerOriginallyHovered.classList.remove('hovered');
        }
        if (card) {
          card.classList.add('hovered');
        }
      });
      el.addEventListener('mouseleave', () => {
        const card = el.closest('.card');
        if (card) {
          card.classList.remove('hovered');
        }
        if (leftContainerOriginallyHovered) {
          leftContainerOriginallyHovered.classList.add('hovered');
        }
      });
    });

    rightHoverElement.forEach((el) => {
      const allCards = document.querySelectorAll('.right-wrapper .card');

      el.addEventListener('mouseenter', () => {
        const currentCard = el.closest('.card');

        allCards.forEach((card) => {
          if (card !== currentCard) {
            card.classList.remove('ideal');
          }
        });
        if (currentCard) {
          currentCard.classList.add('hovered');
        }
      });
      el.addEventListener('mouseleave', () => {
        const currentCard = el.closest('.card');

        allCards.forEach((card) => {
          card.classList.add('ideal');
        });

        if (currentCard) {
          currentCard.classList.remove('hovered');
        }
      });
    });
  }, []);
  return (
    <section className="solution-section">
      <div className="solution-section__header">
        <h2>
          {_.capitalize(ApplicationDomainUtility.partnerName) || productName}&apos;s Innovative <span>Solutions</span>
        </h2>
      </div>
      <div className="solution-section__content ">
        <div className="left-wrapper">
          <div className="card hovered">
            <div className="card-hover"></div>
            <div className="img-circle-blue">
              <img src="/solution-0.svg" alt="Automate Strategy" />
            </div>
            <h3>Algo Strategies</h3>
            <p>
              Build scalable algo strategies in minutes that execute with precision and enhance your trading
              edge.
            </p>
          </div>
          <div className="card">
            <div className="card-hover"></div>
            <div className="img-circle-yellow">
              <img src="/solution-3.svg" alt="Automate Strategy" />
            </div>
            <h3>Backtest with Historical Data</h3>
            <p>Evaluate the potential performance of your developed strategy using historical data.</p>
          </div>
        </div>
        <div className="right-wrapper">
          <div className="card ideal">
            <div className="card-hover"></div>
            <div className="img-circle-red">
              <img src="/solution-2.svg" alt="Automate Strategy" />
            </div>
            <h3>Try Backtesting</h3>
            <p>
              Test your trading strategies on historical market data to refine performance before risking real
              capital.
            </p>
          </div>
          <div className="card ideal">
            <div className="card-hover"></div>
            <div className="img-circle-green">
              <img src="/solution-4.svg" alt="Automate Strategy" />
            </div>
            <h3>No-code</h3>
            <p>
              Easily create, test, and execute trading strategies without any programming or coding skills.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
